// import React, { useContext, useEffect, useState } from 'react';

// import { ConfigContext } from '../../../contexts/ConfigContext';
// import useWindowSize from '../../../hooks/useWindowSize';
// import UseModuloControle from '../../../hooks/useModuloControle';
// import NavContent from './NavContent';
// import { Card } from 'react-bootstrap';
// import { decode as base64_decode } from 'base-64';
// import moment from 'moment';
// import { UPDATEDATAINI } from '../../../store/actions';

// const Navigation = () => {
//   const configContext = useContext(ConfigContext);
//   const { dispatch } = configContext;
//   const { layout, layoutType, navFixedLayout, collapseMenu, rtlLayout, boxLayout, subLayout, headerFixedLayout, menuUsuario, user64, moduloAtual } = configContext.state;
//   const windowSize = useWindowSize();
//   const usersRt = JSON.parse(base64_decode(sessionStorage.getItem(`ddesp`)));
//   const users = usersRt;
//   const [expirou, setExpirou] = useState(users[29]);
//   const primeirosPassos = users[11][0];

//   let menu = users[10];
//   let navigation = '';

//   const [possuiEmpresas, setPossuiEmpresas] = useState(primeirosPassos.possuiEmpresas);
//   const possuiCertificado = primeirosPassos.possuiCert;
//   const primeiroAcesso = primeirosPassos.primeiroAcesso;

//   useEffect(() => {
//     dispatch({ type: UPDATEDATAINI, updateDataIni: true });
//   }, []);

//   useEffect(() => {
//     const storage_ = sessionStorage.getItem(`ddesp`);

//     if (storage_ !== null) {
//       const usersRt = JSON.parse(base64_decode(sessionStorage.getItem(`ddesp`)));
//       const users = usersRt;
//       const PrimeirosPassos = users[11][0];


//       if (configContext.state.updateDataIni === true) {
//         if (users[8] === '4' && users[31] === null) {
//           setExpirou(true);
//         } else if (users[8] === '4' && users[31] !== null) {
//           const dataAtivacaoTeste = moment(users[31]);
//           const dataExpiracao = dataAtivacaoTeste.add(7, 'days');

//           if (moment().isAfter(dataExpiracao)) {
//             setExpirou(true);
//           } else {
//             setExpirou(false);
//           }
//         }
//       }


//       setPossuiEmpresas(PrimeirosPassos.possuiEmpresas);
//     }
//   }, [configContext.state.possuiEmpresas, configContext.state.primeiroAcesso, configContext.state.updateDataIni]);

//   if (menuUsuario.length === 0) {
//       navigation = menu[0][0];
//   } else {
//       navigation = menuUsuario[0];
//   }

//   const scroll = () => {
//     if (navFixedLayout && headerFixedLayout === false) {
//       const main = document.querySelector('.pcoded-navbar');
//       const el = document.querySelector('.pcoded-navbar.menupos-fixed');
//       const scrollPosition = window.pageYOffset;

//       if (scrollPosition > 60) {
//         el.style.position = 'fixed';
//         el.style.transition = 'none';
//         el.style.marginTop = '0';
//       } else {
//         main.style.position = 'absolute';
//         main.style.marginTop = '56px';
//       }
//     } else {
//       document.querySelector('.pcoded-navbar').removeAttribute('style');
//     }
//   };

//   let navClass = ['pcoded-navbar', layoutType];

//   if (layout === 'horizontal') {
//     navClass = [...navClass, 'theme-horizontal'];
//   } else {
//     if (navFixedLayout) {
//       navClass = [...navClass, 'menupos-fixed'];
//     }

//     if (navFixedLayout && !headerFixedLayout) {
//       window.addEventListener('scroll', scroll, true);
//       window.scrollTo(0, 0);
//     } else {
//       window.removeEventListener('scroll', scroll, false);
//     }
//   }

//   if (windowSize.width < 992 && collapseMenu) {
//     navClass = [...navClass, 'mob-open'];
//   } else if (collapseMenu) {
//     navClass = [...navClass, 'navbar-collapsed'];
//   }

//   if (layoutType === 'dark') {
//     document.body.classList.add('gradient-able-dark');
//   } else {
//     document.body.classList.remove('gradient-able-dark');
//   }

//   if (rtlLayout) {
//     document.body.classList.add('gradient-able-rtl');
//   } else {
//     document.body.classList.remove('gradient-able-rtl');
//   }

//   if (boxLayout) {
//     document.body.classList.add('container');
//     document.body.classList.add('box-layout');
//   } else {
//     document.body.classList.remove('container');
//     document.body.classList.remove('box-layout');
//   }

//   let navBarClass = ['navbar-wrapper'];
//   if (layout === 'horizontal' && subLayout === 'horizontal-2') {
//     navBarClass = [...navBarClass, 'container'];
//   }
//   let navContent = (
//     <div className={navBarClass.join(' ')}>
//       <NavContent navigation={navigation.items} />
//     </div>
//   );
//   if (windowSize.width < 992) {
//     navContent = (
//       <div className='navbar-wrapper'>
//         <NavContent navigation={navigation.items} />
//       </div>
//     );
//   }

//   if ((possuiEmpresas === false && possuiCertificado === false) || primeiroAcesso === true || expirou === true ) {
//     navContent = (
//       <Card>
//         <Card.Body className='text-center'>
//           <i className='fas fa-question-circle f-40'></i>
//           <h6 className='mt-3'>Precisa de ajuda?</h6>
//           <p>Não fique com dúvidas! Acesse nossa Central de Ajuda.</p>
//           <a
//             id='btnAjudaIni'
//             href='https://ajuda.espiaonfe.com.br'
//             target='_blank'
//             className='btn btn-primary btn-sm text-white m-0 text-decoration-none'
//             rel='noreferrer'
//           >
//             Ajuda
//           </a>
//         </Card.Body>
//       </Card>
//     );
//   }
//   return (
//     <React.Fragment>
//       <nav className={navClass.join(' ')}>{navContent}</nav>
//     </React.Fragment>
//   );
// };

// export default Navigation;

import React, { useContext, useEffect } from 'react';
import { ConfigContext } from '../../../contexts/ConfigContext';
import useWindowSize from '../../../hooks/useWindowSize';
import { useModuloControle } from '../../../contexts/ModuloControleContext';
import NavContent from './NavContent';
import CardAjuda from '../../../components/Ajuda/CardAjuda';
import { UPDATEDATAINI } from '../../../store/actions';

const Navigation = () => {
  const configContext = useContext(ConfigContext);
  const { dispatch, state } = configContext;
  const {
    bloquearMenu,
    primeiroAcesso,
    possuiEmpresas,
    possuiCertificado,
    expirouDemonstracao,
    menuGestao,
  } = useModuloControle();

  const { layout, layoutType, navFixedLayout, collapseMenu, rtlLayout, boxLayout, subLayout, headerFixedLayout, menuUsuario, moduloAtual } = state;
  const windowSize = useWindowSize();


  useEffect(() => {
    dispatch({ type: UPDATEDATAINI, updateDataIni: true });
  }, [dispatch]);

  
  const navigation = menuUsuario.length === 0 ? menuGestao : menuUsuario[0];

  const scroll = () => {
    if (navFixedLayout && !headerFixedLayout) {
      const el = document.querySelector('.pcoded-navbar.menupos-fixed');
      const scrollPosition = window.pageYOffset;
      if (scrollPosition > 60) {
        el.style.position = 'fixed';
        el.style.transition = 'none';
        el.style.marginTop = '0';
      } else {
        el.style.position = 'absolute';
        el.style.marginTop = '56px';
      }
    } else {
      document.querySelector('.pcoded-navbar')?.removeAttribute('style');
    }
  };

  let navClass = ['pcoded-navbar', layoutType];

  if (layout === 'horizontal') {
    navClass.push('theme-horizontal');
  } else {
    if (navFixedLayout) navClass.push('menupos-fixed');
    if (navFixedLayout && !headerFixedLayout) {
      window.addEventListener('scroll', scroll, true);
      window.scrollTo(0, 0);
    } else {
      window.removeEventListener('scroll', scroll, false);
    }
  }

  if (windowSize.width < 992 && collapseMenu) {
    navClass.push('mob-open');
  } else if (collapseMenu) {
    navClass.push('navbar-collapsed');
  }

  document.body.classList.toggle('gradient-able-dark', layoutType === 'dark');
  document.body.classList.toggle('gradient-able-rtl', rtlLayout);
  document.body.classList.toggle('container', boxLayout);
  document.body.classList.toggle('box-layout', boxLayout);

  const navBarClass = ['navbar-wrapper'];
  if (layout === 'horizontal' && subLayout === 'horizontal-2') {
    navBarClass.push('container');
  }

  let navContent = (
    <div className={navBarClass.join(' ')}>
      <NavContent navigation={navigation.items} />
    </div>
  );

  if (bloquearMenu.gestao) {
    navContent = (
     <CardAjuda />
    );
  }

  return (
    <nav className={navClass.join(' ')}>
      {navContent}
    </nav>
  );
};

export default Navigation;
